import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorImage from '@root/assets/error.png';
import Button from '../Button';
import './index.less';

const PageLoadError = ({
  children,
  onTryAgain,
}: {
  children?: ReactNode;
  onTryAgain?: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <div className="page-load-error">
      <div className="img">
        <img className="error-image" src={ErrorImage} />
      </div>
      <p className="error-msg">{children || t('load_error_message')}</p>

      {!!onTryAgain && (
        <Button size="auto" onClick={onTryAgain}>
          {t('try_again')}
        </Button>
      )}
    </div>
  );
};

export default PageLoadError;
